<template>
  <div class="d-flex justify-content-center p-5">
    <iframe
      class="video-intro"
      frameborder="0"
      :src="srcVideo"
    /> 
  </div>
</template>

<script>
export default {
  data() {
    return {
      srcVideo: 'https://www.youtube.com/embed/kVCdAs5ergE'
    }
  },
}
</script>

<style>

</style>